
export const AssignmentStatus = {
	NEW: 'new',
	RESOURCE_ASSIGNED: 'resource-assigned',
	IN_PROGRESS: 'in-progress',
	COMPLETED: 'completed',
	CANCELED: 'canceled',
};